import { ConfirmDialog } from "../../modal/ConfirmDialog";
import { useMemberProfile } from "../MemberProfileContext";

export function OnboardingByPhoneConfirm({
    enable,
    onClose,
}: {
    enable: boolean;
    onClose: () => void;
}) {
    const { profile, setOnboardingByPhone, saving } = useMemberProfile();

    return (
        <ConfirmDialog
            open
            title={
                enable ? "Complete onboarding by phone" : "Return onboarding to the app"
            }
            description={
                enable
                    ? `${profile.memberName} will not be asked the onboarding questions in the app, and no automated welcome message will be sent.`
                    : `${profile.memberName} will be asked the onboarding questions in the app again, and the automated welcome message will be sent when they first sign in.`
            }
            confirmLabel={enable ? "Complete by phone" : "Return to the app"}
            confirmDisabled={saving}
            onConfirm={() => {
                setOnboardingByPhone(enable, onClose);
            }}
            onDismiss={onClose}
        />
    );
}
